import styled, { css } from 'styled-components';

import { elevation } from "../Styles/Utils";

export const Input = /*#__PURE__*/styled.input.withConfig({ displayName: "styles__Input", componentId: "sc-7h6wpw-0" })(["position:absolute;top:0;left:0;right:0;bottom:0;margin:0;opacity:0;width:100%;height:100%;appearance:none;cursor:pointer;z-index:1;"]);














export const RadioButton = /*#__PURE__*/styled.button.withConfig({ displayName: "styles__RadioButton", componentId: "sc-7h6wpw-1" })(["position:relative;max-width:100%;flex:0 0 auto;height:40px;padding:6px;margin-right:8px;margin-bottom:8px;border-radius:8px;transition:all cubic-bezier(0.4,0,0.2,1) 0.3s;-webkit-tap-highlight-color:transparent;outline:0;border-style:solid;border-width:2px;border-color:", ";color:", ";background-color:", ";:hover,:focus{border-color:transparent;", "}", ""],













(props) => props.theme.colors['Level 1'],
(props) => props.theme.colors['Level 5'],
(props) => props.theme.colors.ElementBackground,




elevation(2, true),


(props) =>
props.isChecked &&
css(["color:white;border-color:transparent;background-color:", ";"],


props.theme.colors.secondary));



export const Label = /*#__PURE__*/styled.label.withConfig({ displayName: "styles__Label", componentId: "sc-7h6wpw-2" })(["display:flex;justify-content:center;align-items:center;color:inherit;overflow:hidden;"]);







export const Text = /*#__PURE__*/styled.span.withConfig({ displayName: "styles__Text", componentId: "sc-7h6wpw-3" })(["", " color:inherit;text-align:center;line-height:24px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"],
(props) => props.theme.typography.Paragraph);








export const GroupContainer = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__GroupContainer", componentId: "sc-7h6wpw-4" })(["max-width:100%;display:flex;flex-wrap:wrap;margin-right:-8px;margin-bottom:-8px;"]);